<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://sised.com.co" target="_blank">Sised</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Creado por </span>
      <a href="https://sised.com.co" target="_blank">Carlos Gerardo Galeano Flórez</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
